import { Box, Checkbox, Dialog, DialogContent, InputAdornment, Pagination, Stack, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { dashboardIcon, farmers, region } from "../../config/images";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { addCertificationAndTraining, certificationAndTraining, certificationsTrainingExcel, deleteCertificationAndTraining, editCertificationAndTraining, importCertificationAndTrainingExcel, } from "../../config/services";
import { Button } from "../../components/Button/button";
import translations from "../../config/language";
import { downloadFile } from "../../config/DownloadFile";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const CertificationData = () => {
  const [editCategory, setEditCategory] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(false);
  const [addCategory, setAddCategory] = useState(false);
  const [importExcel, setImportExcel] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [cropsData, setCropsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [addCategoryData, setAddCategoryData] = useState("");
  const [editCategoryData, setEditCategoryData] = useState("");
  const [editId, setEditId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();
  const [loading, setIsLoading] = useState(false);
  const [importExcelLoading, setImportExcelLoading] = useState(false);

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Certifications & Training" && module.is_editor === true
  ) ? true : false;
  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (fileType === 'xlsx' || fileType === 'xls') {
        setSelectedFile(file);
      } else {
        notifyError(translations[language].pleaseSelectExcelFile || 'Please select an Excel file');
        event.target.value = null; // Reset file input
      }
    }
  };

  useEffect(() => {
    handlegetCropsData();
  }, [currentPage]);

  const handlegetCropsData = async () => {
    try {
      const resp = await certificationAndTraining(currentPage, perPage);
      if (resp.status == 200 || resp.status == 201) {
        setCropsData(resp?.data?.results?.payload);
        setCount(resp.data.count);
      }
    } catch (error) {
      setCropsData([]);
    }
  };
  const filteredCrops = cropsData.filter((crop) =>
    crop.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAddData = async (event) => {
    event.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!addCategoryData) {
      notifyError("Enter Certification & Training");
      return;
    }
    const params = {
      name: addCategoryData,
    };
    try {
      setIsLoading(true);
      const resp = await addCertificationAndTraining(params);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setAddCategory(false);
        handlegetCropsData();
        setAddCategoryData("");
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setAddCategory(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      setAddCategoryData("");
    }
  };
  const handleCancel = (e) => {
    if (e) e.preventDefault(); // Prevents default behavior (useful for form buttons)
    setAddCategory(false); // Closes the popup
    setEditCategory(false);
    setAddCategoryData("");
    setDeleteCategory(false);
  };
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handleEditPopup = (e) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setEditId(e.id);
    setEditCategory(true);
    setEditCategoryData(e.name);
  };

  const handleEditCategory = async (event) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    event.preventDefault();
    if (!editCategoryData) {
      notifyError("Enter Certification & Training");
      return;
    }
    const params = {
      name: editCategoryData,
    };
    try {
      setIsLoading(true);
      const resp = await editCertificationAndTraining(params, editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setEditCategory(false);
        handlegetCropsData();
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setEditCategory(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  const handleDeletePopup = (e) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setEditId(e.id);
    setDeleteCategory(true);
  };

  const handleDeleteDta = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      setIsLoading(true);
      const resp = await deleteCertificationAndTraining(editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setDeleteCategory(false);
        handlegetCropsData();
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setDeleteCategory(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  const handleDemoFile = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      const res = await certificationsTrainingExcel();
      if (res.data.success == true) {
        downloadFile(res);
        notifySuccess(translations[language].downloadSuccess);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response?.data?.message || translations[language].downloadFailed);
    }
  }

  const handleImportExcel = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!selectedFile) {
      notifyError(translations[language].pleaseSelectFile);
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      setImportExcelLoading(true);
      const resp = await importCertificationAndTrainingExcel(formData);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        handlegetCropsData();
        setImportExcel(false);
        setSelectedFile(null);
        setImportExcelLoading(false);
      }
    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setImportExcel(false);
      setSelectedFile(null);
      setImportExcelLoading(false);
    }
  }

  const language = process.env.REACT_APP_LANGUAGE;

  return (
    <>
      <Box className="task-assign-box">
        <Box
          className="d-flex justify-content-between align-items-center"
          style={{ flexWrap: "wrap" }}
        >
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img src={dashboardIcon.certification} alt="" />
            <Typography variant="h6" gutterBottom>
              {translations[language].certificationsAndTraining}
            </Typography>
          </Box>
          <Box className="assign-data-btn">
            <img
              src={region.deleteIcon}
              alt=""
              style={{ marginRight: "10px" }}
              className="delete-btn"
            />
            <button className="deactivate-btn" style={{ marginRight: "10px" }} onClick={() => handleDemoFile()}>
              {translations[language].demoFile}
            </button>
            <button
              className="deactivate-btn"
              style={{ marginRight: "10px" }}
              onClick={() => {
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return true;
                }
                setImportExcel(true)}
              }
            >
              {translations[language].importExcel}
            </button>

            <button
              className="assign-task-btn"
              style={{ marginLeft: "0px" }}
              onClick={() => setAddCategory(true)}
            >
              {translations[language].addCertificationAndTraining}
            </button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder={translations[language].searchHere}
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  {translations[language].search}
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <div className="crop-table-container">
          <Table className="region-table pt-1" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "50px" }}>
                  <Checkbox
                    sx={{
                      color: "rgba(225, 230, 244, 1)",
                      borderRadius: "4px",
                      "&.Mui-checked": {
                        color: "rgba(199, 206, 227,1)",
                      },
                    }}
                  />
                </TableCell>
                <TableCell style={{ width: "100px", textAlign: "center" }}>
                  {translations[language].srNo}
                </TableCell>
                <TableCell>{translations[language].certificationsAndTraining} Name</TableCell>
                <TableCell style={{ width: "100px" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCrops.length > 0 ? (
                filteredCrops?.map((e, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell>
                        <Checkbox
                          sx={{
                            color: "rgba(225, 230, 244, 1)",
                            borderRadius: "4px",
                            "&.Mui-checked": {
                              color: "rgba(199, 206, 227,1)",
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {i + 1 + (currentPage - 1) * perPage}
                      </TableCell>
                      <TableCell>{e.name}</TableCell>
                      <TableCell>
                        <div className="d-flex gap-3">
                          <img
                            src={region.editIcon}
                            alt=""
                            onClick={() => handleEditPopup(e)}
                            style={{ cursor: "pointer", height: "23px" }}
                          />
                          <img
                            src={region.deleteIcon}
                            alt=""
                            onClick={() => handleDeletePopup(e)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={4} style={{ textAlign: "center" }}>
                    <img src={farmers.noData} alt="No Data" />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <Box
          display="flex"
          justifyContent="end"
          alignItems="center"
          className="pagination"
        >
          <Stack spacing={2} className="mb-3">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handleChange}
              color="primary"
            />
          </Stack>
        </Box>
        <Dialog
          open={addCategory}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px", maxWidth: "514px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].addCertificationAndTraining}
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label={translations[language].enterCertificationAndTraining}
                name="addCategoryData"
                value={addCategoryData}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setAddCategoryData(value);
                  }
                }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button className="cancel-button" onClick={handleCancel}>
                  {translations[language].cancel}
                </button>

                <Button
                  title={translations[language].addCertificationAndTraining}
                  classname={"assign-task-button"}
                  onClick={handleAddData}
                  loading={loading}
                />
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={editCategory}
          // onClose={() => setEditCategory(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px", maxWidth: "560px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].editCertificationAndTraining}
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label={translations[language].enterCertificationAndTraining}
                name="taskTitle"
                value={editCategoryData}
                className="mb-3"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setEditCategoryData(value);
                  }
                }}
              />

              <div className="d-flex gap-3 mt-2">
                <button className="cancel-button" onClick={handleCancel}>
                  {translations[language].cancel}
                </button>
                <Button
                  title={translations[language].updateCertificationAndTraining}
                  classname={"assign-task-button"}
                  onClick={handleEditCategory}
                  loading={loading}
                />
              </div>
            </form>
          </DialogContent>
        </Dialog>

        <Dialog
          open={deleteCategory}
          // onClose={() => setDeleteCategory(false)}
          maxWidth="xs"
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <DialogContent className="p-5" style={{ textAlign: "center" }}>
            <Box>
              <img src={region.correct} alt="" />
            </Box>
            <Typography variant="h5" className="pt-4 mb-2">
              <b>{translations[language].deleteCertificationAndTraining} </b>
            </Typography>
            <Typography
              variant="p"
              className="pt-4"
              style={{ fontSize: "16px" }}
            >
              {translations[language].deleteCertificationAndTrainingConfirmation}
            </Typography>
            <div className="d-flex gap-3 pt-4">
              <Button
                title={translations[language].yes}
                classname={"assign-task-button"}
                onClick={handleDeleteDta}
                loading={loading}
              />
              <button className="assign-task-button" onClick={handleCancel}>
                {translations[language].no}
              </button>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={importExcel}
          // onClose={() => setImportExcel(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].importExcel}
              </h5>
            </div>
          </div>
          <DialogContent>
            <Box textAlign="center">
              <input
                type="file"
                accept=".xlsx, .xls"
                id="file-upload"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label htmlFor="file-upload">
                <Box
                  sx={{
                    width: "390px",
                    height: "150px",
                    border: "2px dashed #3C4856",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    boxShadow: "0px 4px 10px rgba(160, 160, 160, 0.16)",
                  }}
                >
                  {selectedFile ? (
                    <Box textAlign="center">
                      <img
                        src={region.browseImage}
                        alt="Excel"
                        style={{ width: 50, height: 50, marginBottom: 8 }}
                      />
                      <Box sx={{ fontSize: "14px", fontWeight: 500 }}>
                        {selectedFile.name}
                      </Box>
                      <Box sx={{ fontSize: "12px", color: "#555" }}>
                        {(selectedFile.size / 1024).toFixed(1)} KB
                      </Box>
                    </Box>
                  ) : (
                    <img src={region.browseImage} alt="" />
                  )}
                </Box>
              </label>
              <div className="d-flex gap-3 mt-4">
                <button
                  className="cancel-button"
                  onClick={(e) => {
                    e.preventDefault();
                    setImportExcel(false);
                  }}
                >
                  {translations[language].cancel}
                </button>
                <button
                  className="assign-task-button"
                  onClick={(e) => handleImportExcel(e)}
                  style={{ cursor: importExcelLoading ? "not-allowed" : "pointer" }}
                  loading={importExcelLoading}
                  disabled={importExcelLoading}
                >
                  {translations[language].submit}
                </button>
              </div>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};

export default CertificationData;
